import { Observable } from 'rxjs'
import { TrackerHistoryPayload } from '@app/modules/client/map/shared/models/tracker-history-payload.model'
import { SocketState } from '@app/modules/client/map/shared/abstractSocket.directive'

export abstract class MapRealtimeGateway {
  abstract socketState$: Observable<SocketState>
  abstract isConnected(state: SocketState): boolean
  abstract subscribe(vehicleIds: number[]): void
  abstract getCoordinates(): Observable<TrackerHistoryPayload>
  abstract close(): void
}
